import React from 'react';
import { ArrowRight } from 'lucide-react';
import { journeyContent } from '../data/mockData';
import { useScrollReveal } from '../hooks/useScrollReveal';

const JourneySection = () => {
  const [sectionRef, isSectionVisible] = useScrollReveal();

  return (
    <section id="about" className="relative py-24 lg:py-32 overflow-hidden">
      {/* Background Image with Overlay */}
      <div className="absolute inset-0">
        <img
          src="https://images.unsplash.com/photo-1504384308090-c894fdcc538d?w=1200&h=675&fit=crop&fm=webp&q=70"
          alt="Technology Background"
          className="w-full h-full object-cover"
        />
        <div className="absolute inset-0 bg-gradient-to-r from-black/85 via-black/75 to-black/60"></div>
      </div>

      <div
        ref={sectionRef}
        className={`relative z-10 section-container reveal ${isSectionVisible ? 'visible' : ''}`}
      >
        <div className="grid lg:grid-cols-5 gap-8 items-center">
          {/* Mascot - pointing towards the text */}
          <div className="hidden lg:flex lg:col-span-2 justify-center">
            <div className="relative">
              <img
                src="/immi-pointing-nobg.webp"
                alt="Immi mascot pointing"
                className="w-72 h-auto"
                style={{ animation: 'mascot-float 4s ease-in-out infinite', filter: 'drop-shadow(0 20px 40px rgba(0,188,228,0.4))', mixBlendMode: 'screen' }}
              />
              {/* Glow effect behind */}
              <div className="absolute -inset-4 bg-[#00BCE4]/15 rounded-full blur-3xl -z-10"></div>
            </div>
          </div>

          {/* Text content */}
          <div className="lg:col-span-3 text-center lg:text-right">
          {/* Subtitle */}
          <span
            className="inline-block text-[#00BCE4] text-sm font-semibold uppercase tracking-[3px] mb-4"
            style={{ fontFamily: 'Outfit, sans-serif' }}
          >
            {journeyContent.subtitle}
          </span>

          {/* Title */}
          <h2
            className="text-4xl md:text-5xl lg:text-6xl font-bold text-white mb-10 leading-tight"
            style={{ fontFamily: 'Outfit, sans-serif' }}
          >
            {journeyContent.title}
          </h2>

          {/* Paragraphs */}
          <div className="space-y-6">
            {journeyContent.paragraphs.map((paragraph, index) => (
              <p
                key={`para-${index}`}
                className="text-base md:text-lg text-gray-300 leading-relaxed"
                style={{ fontFamily: 'Inter, sans-serif' }}
              >
                {paragraph}
              </p>
            ))}
          </div>

          {/* CTA */}
          <div className="mt-10">
            <a
              href="#contact"
              onClick={(e) => {
                e.preventDefault();
                document.getElementById('contact')?.scrollIntoView({ behavior: 'smooth' });
              }}
              className="btn-primary text-xs"
            >
              Let's Talk
              <ArrowRight size={16} />
            </a>
          </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default JourneySection;
